export const createUpdateStateFunction = (
  state: number[],
  setState: React.Dispatch<React.SetStateAction<number[]>>
) => function(id: number){
  state.includes(id)
    ? setState(state.filter((item) => item !== id))
    : setState([...state, id]);
};